var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.151 12.755a7.04 7.04 0 111.45-1.398l3.083 2.905a1.006 1.006 0 11-1.38 1.464l-3.153-2.97zm.917-5.715a5.028 5.028 0 11-10.056 0 5.028 5.028 0 0110.056 0z","fill":"#1B1B1B"}));
}

Search.defaultProps = {"width":"16","height":"16","fill":"none"};

module.exports = Search;

Search.default = Search;
